<template>
  <v-dialog :value="isActive" @click:outside="closeDialog" max-width="700" scrollable>
    <ValidationObserver ref="obs" v-slot="{ handleSubmit }">
      <v-card>
        <v-card-title class="pa-0 shadow-1">
          <v-card-title class="font-weight-medium primary--text">
            Enviar mensaje rápido
          </v-card-title>
        </v-card-title>

        <v-card-text style="max-height: 600px; overflow-y: auto;">
          <v-form>
            <v-row dense justify="center">
              <v-col cols="12" class="py-0">
                <ValidationProvider name="WhatsApp" rules="required" v-slot="{ errors }">
                  <v-select
                    :disabled="isLoading"
                    v-model="selectedItem"
                    :items="whatsappList"
                    :error-messages="errors"
                    item-text="name"
                    item-value="id"
                    return-object
                    prepend-inner-icon="mdi-account"
                    label="WhatsApp"
                    filled
                    rounded
                    class="rounded-small"
                    @change="getTemplatesList"
                  >
                    <template v-slot:item="{ item, on, attrs }">
                      <v-list-item two-line selectable v-on="on" v-bind="attrs" class="pl-3">
                        <template>
                          <v-list-item-content>
                            <v-list-item-title>
                              {{ item.name + " " }}
                            </v-list-item-title>

                            <v-list-item-subtitle>
                              {{ item.number }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </v-list-item>
                    </template>
                  </v-select>
                </ValidationProvider>
              </v-col>

              <!-- Numero -->
              <v-col cols="12">
                <!-- {{ "available: " + available }} -->
                <ValidationProvider name="número" :rules="{ required: true, regex: /^[0-9+]+$/ }" v-slot="{ errors }">
                  <v-text-field
                    v-model="payload.number"
                    :error-messages="errors"
                    class="rounded-small"
                    label="Número"
                    prepend-inner-icon="mdi-numeric"
                    required
                    filled
                    rounded
                    dense
                    clearable
                    @change="validateNumber"
                    :disabled="selectedItem == null || module === 'contacts'"
                  >
                  </v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Plantilla -->
              <v-col cols="12" class="py-0" v-if="available === 1">
                <template v-if="[4, 6].includes(selectedItem.type)">
                  <ValidationProvider name="plantilla" rules="required" v-slot="{ errors }">
                    <v-select
                      :disabled="isLoadingTemplates"
                      v-model="selectTemplate"
                      :items="templatesList"
                      :error-messages="errors"
                      item-text="title"
                      item-value="id"
                      return-object
                      prepend-inner-icon="mdi-account"
                      label="Plantilla"
                      filled
                      rounded
                      class="rounded-small"
                      @change="onTemplateChange"
                    >
                    </v-select>
                  </ValidationProvider>
                </template>
              </v-col>

              <!-- Mensaje -->
              <v-col cols="12" v-if="available === 1">
                <template v-if="[4, 6].includes(selectedItem.type)">
                  <v-card flat color="grey lighten-3" v-show="selectTemplate != []">
                    <v-card-text>
                      {{ selectTemplate.message }}
                    </v-card-text>
                  </v-card>
                </template>

                <template v-else>
                  <ValidationProvider name="mensaje" rules="required" v-slot="{ errors }">
                    <v-textarea
                      v-model="payload.message"
                      :error-messages="errors"
                      class="rounded-small"
                      label="Mensaje"
                      prepend-inner-icon="mdi-message-text"
                      required
                      filled
                      rounded
                      dense
                      clearable
                      :disabled="selectedItem == null"
                    >
                    </v-textarea>
                  </ValidationProvider>
                </template>
              </v-col>

              <v-col cols="12" v-else-if="available == 2">
                <v-card flat color="grey lighten-3">
                  <v-card-text>
                    Este número de teléfono ya possee un ticket abierto. ¿Desea enviarle un mensaje?
                  </v-card-text>
                  <v-container>
                    <v-card outlined>
                      <v-card-text>
                        <v-list-item two-line>
                          <v-list-item-content>
                            <v-list-item-title>{{ openTicket.agent }}</v-list-item-title>
                            <v-list-item-subtitle>{{ openTicket.date }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-card-text>
                    </v-card>
                  </v-container>
                  <v-card-actions>
                    <v-btn text color="error" @click="cancelNumber">No</v-btn>
                    <v-btn text color="success" @click="available = 1">
                      Sí
                    </v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-col>

              <v-col cols="12" v-if="parameter_number > 0" dense>
                <v-card outlined>
                  <v-card-text>
                    <p>Parámetros</p>
                    <v-row dense>
                      <v-col v-for="(paramName, index) in parameter" :key="index" cols="12">
                        <ValidationProvider :name="paramName" rules="required" v-slot="{ errors }">
                          <v-text-field
                            :label="paramName"
                            :placeholder="`Ingrese ${paramName}`"
                            v-model="payload.parameters[index]"
                            filled
                            rounded
                            clearable
                            :error-messages="errors"
                            class="rounded-small"
                          />
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="mx-2 justify-end">
          <v-spacer></v-spacer>
          <v-hover v-slot:default="{ hover }">
            <v-btn text rounded class="mr-1" :color="hover ? 'error' : 'grey'" @click="closeDialog">
              Cancelar
            </v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              :disabled="isSendingMessage || (![4, 6].includes(selectedItem.type) && payload.message === '')"
              rounded
              color="success"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-8"
              @click="handleSubmit(submitForm)"
            >
              Enviar
            </v-btn>
          </v-hover>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
export default {
  props: {
    isActive: {
      type: Boolean,
    },
    agent: {
      type: String,
    },
    number: {
      type: String,
    },
    module: {
      type: String,
    },
  },

  data: () => ({
    isLoading: false,
    isSendingMessage: false,
    isLoadingTemplates: false,
    available: 0,
    selectedItem: null,
    payload: {
      template_id: null,
      message: "",
      number: "",
      config_id: null,
    },
    parameter_number: null,
    parameter: [],
    whatsappList: [],
    templatesList: [],
    selectTemplate: [],
    openTicket: {
      agent: "",
      date: "",
    },
  }),

  watch: {
    selectTemplate(newTemplate) {
      if (newTemplate && newTemplate.parameter_number > 0) {
        this.parameter_number = newTemplate.parameter_number;
        this.parameter = newTemplate.parameter;
        this.payload.parameters = new Array(newTemplate.parameter_number).fill(""); // Inicializa
      } else {
        this.parameter_number = 0;
        this.parameter = [];
        this.payload.parameters = [];
      }
    },
  },

  created() {
    if (this.number) {
      this.payload.number = this.number;
    }

    this.getWhatsappList();
  },

  methods: {
    cancelNumber() {
      this.available = 0;
      this.payload.number = "";
    },

    async getWhatsappList() {
      try {
        const { data } = await PbxHttpClient.get("/whatsapps/config/index_select");
        this.whatsappList = data;
      } catch (err) {
        this.$snotify.error("No se pudo obtener la lista de whatsapp", "¡Error!");
      }
    },

    /**
     * Al seleccionar una plantilla, se actualizan los parámetros y el número de parámetros,
     * además se reinicia el array de valores en `payload.parameters`.
     */
    onTemplateChange() {
      if (this.selectTemplate && this.selectTemplate.parameter_number > 0) {
        this.parameter_number = this.selectTemplate.parameter_number;
        this.parameter = this.selectTemplate.parameters;

        // Inicializar array con valores vacíos para los parámetros
        this.payload.parameters = this.parameter.map(() => "");
      } else {
        this.parameter_number = null;
        this.parameter = [];
        this.payload.parameters = [];
      }
    },

    /**
     * Obtiene la lista de plantillas desde el backend y la filtra según el ID de WhatsApp seleccionado.
     * No se asignan los parámetros aquí, ya que se gestionan al seleccionar la plantilla.
     *
     * @returns {Promise<void>}
     */
    async getTemplatesList() {
      this.selectTemplate = [];
      this.isLoadingTemplates = true;

      try {
        const { data } = await PbxHttpClient.get("/templates-Meta");

        // Filtrar plantillas según el WhatsApp ID seleccionado
        this.templatesList = data.data.filter((template) => template.whatsapp_id === this.selectedItem.id);
      } catch (err) {
        this.$snotify.error("No se pudo obtener la lista de whatsapp", "¡Error!");
      } finally {
        this.isLoadingTemplates = false;
        if (this.module === "contacts") {
          this.validateNumber();
        }
      }
    },

    // async getTemplatesList() {
    //   this.selectTemplate = [];
    //   this.isLoadingTemplates = true;
    //   try {
    //     const { data } = await PbxHttpClient.get("/templates-Meta");
    //     this.templatesList = data.data.filter((template) => template.whatsapp_id === this.selectedItem.id);

    //     if (data.data.parameter_number > 0) {
    //       this.parameter_number = data.data.parameter_number;
    //       this.parameter = data.data.parameters;
    //     } else {
    //       this.parameter_number = null;
    //       this.parameter = [];
    //     }
    //   } catch (err) {
    //     this.$snotify.error("No se pudo obtener la lista de whatsapp", "¡Error!");
    //   } finally {
    //     this.isLoadingTemplates = false;
    //     if (this.module === "contacts") {
    //       this.validateNumber();
    //     }
    //   }
    // },

    async submitForm() {
      this.$store.commit("layout/SET_OVERLAY", {
        value: true,
        title: "Enviando",
      });
      this.isSendingMessage = true;
      this.payload.config_id = this.selectedItem.id;

      if ([4, 6].includes(this.selectedItem.type)) {
        this.payload.template_id = this.selectTemplate.id;
        this.payload.message = "*" + this.agent + "*: \n" + this.selectTemplate.message;
      } else {
        this.payload.message = "*" + this.agent + "*: \n" + this.payload.message;
      }

      try {
        await PbxHttpClient.post("/whatsapps/send_messages_number", this.payload);

        this.closeDialog();
        this.$snotify.success("Mensaje enviado con éxito.", "¡Hecho!");
      } catch (err) {
        this.$snotify.error("No se pudo enviar el mensaje", "¡Error!");
      } finally {
        this.isSendingMessage = false;
        this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
      }
    },

    async validateNumber() {
      this.$store.commit("layout/SET_OVERLAY", {
        value: true,
        title: "Cargando",
      });
      this.isSendingMessage = true;
      try {
        const { data } = await PbxHttpClient.post("/whatsapps/consult_messages_fast", {
          number: this.payload.number,
          config_id: this.selectedItem.id,
        });

        // console.log("validacion", data);

        if (data.succes) {
          if (data.message === "Número disponible") {
            this.$snotify.success(data.message, "Disponible");
            this.available = 1;
          } else {
            this.$snotify.warning(data.message);
            this.available = 2;
            this.openTicket.agent = data.ticket.user_name.name;
            this.openTicket.date = data.ticket.updated_at;
          }
        }
      } catch (err) {
        this.$snotify.error("consultar", "¡Error!");
      } finally {
        this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
        this.isSendingMessage = false;
      }
    },
    async closeDialog() {
      await this.$refs.obs.reset();
      this.payload = {
        message: "",
        number: "",
        config_id: null,
      };
      this.cancelNumber();
      this.$emit("dialog:close");
    },
  },
};
</script>

<style></style>
